// extracted by mini-css-extract-plugin
export default {"editLink":"regulation-strategy-defaults_editLink__ZVzJG"};